import classNames from "classnames";

import { MECHANIC_SKU_PRICE_TIERING_TYPE } from "../../constants/mechanic";

import { PriceDiscount } from "../ui";

function SkuPriceTiers(props) {
  const { tiers, nextTier, skuPrice, mechanicSkuPriceTieringType } = props;

  function getPriceTierView(tier) {
    let priceTierView;
    if (
      mechanicSkuPriceTieringType ===
      MECHANIC_SKU_PRICE_TIERING_TYPE.EXACT_QUANTITY
    ) {
      priceTierView = (
        <span>زود الكمية حتي {tier.quantity} ليصبح سعر القطعة</span>
      );
    } else if (
      mechanicSkuPriceTieringType === MECHANIC_SKU_PRICE_TIERING_TYPE.RANGE &&
      tier.maxQuantity
    ) {
      priceTierView = (
        <span>
          ضيف كمية ما بين{" "}
          <span>
            {tier.minQuantity} - {tier.maxQuantity}
          </span>{" "}
          ليصبح سعر القطعة
        </span>
      );
    } else if (
      mechanicSkuPriceTieringType === MECHANIC_SKU_PRICE_TIERING_TYPE.RANGE &&
      !tier.maxQuantity
    ) {
      priceTierView = (
        <span>
          ضيف كمية تساوي <span>{tier.minQuantity}</span> فيما فوق ليصبح سعر
          القطعة
        </span>
      );
    }

    return priceTierView;
  }

  return (
    <ul className="my-4 mx-auto pr-4 list-disc text-center w-fit">
      {tiers.map((tier) => (
        <li
          key={tier.id}
          className={classNames({
            "bg-slate-100 border border-slate-400 rounded-md px-1 font-extrabold":
              tier.id === nextTier?.id,
          })}
        >
          <div className="flex flex-wrap gap-2 md:gap-4">
            <p className="flex-grow">{getPriceTierView(tier)}</p>
            <PriceDiscount
              oldPrice={skuPrice}
              newPrice={tier.price}
              className="flex-grow"
            />
          </div>
        </li>
      ))}
    </ul>
  );
}

export default SkuPriceTiers;
